export function addSticker(dateOfUpdate, stickerDays, renderSticker) {
	let sticker = false;

	var date = new Date(dateOfUpdate);
	var today = new Date();
	var day = 24 * 60 * 60 * 1000;
	var interval = parseInt(stickerDays);

	if (!Number.isNaN(date) && renderSticker !== "None") {
		sticker = Math.round(Math.abs((today - date) / day)) <= interval ? true : false;
	}
	return sticker;
}

export function findAnchor(anchor) {
	var anchor = anchor.match(/(\d+)/)[0];

	var el = document.querySelector("#shadow-root").shadowRoot.getElementById(anchor);
	var aAlert = document.querySelector("#shadow-root").shadowRoot.getElementById("brokenAnchorAlert");

	if (el) {
		aAlert.classList.add("d-none");
		el.classList.add("fadeFound", "found");
		el.querySelector(".collapse").classList.add("show");
	} else {
		aAlert.classList.remove("d-none");
		el = aAlert;
	}

	el.scrollIntoView();
	setTimeout(function () {
		el.classList.remove("found");
	}, 5000);
}

export function excerptHighlight(text, textToHighlight, trim) {
	if (!text) return "";
	var regex = new RegExp(textToHighlight, "gi");

	if (trim) {
		let strPos = text.indexOf(textToHighlight);
		var shortText = text.slice(Math.max(0, strPos - 80), strPos + textToHighlight.length + 80);
		return shortText.replace(regex, (match) => `<mark>${match}</mark>`);
	}
	return text.replace(regex, (match) => `<mark>${match}</mark>`);
}

export function omniToggler() {
	var shadowRoot = document.querySelector("#shadow-root").shadowRoot;
	var buttons = shadowRoot.querySelectorAll(".panelTrigger");

	buttons.forEach((item) => {
		item.click();
	});
}
